module.exports = __webpack_public_path__ + "img/coupon-icon.9362539.png";